export default __webpack_public_path__ + "static/media/Inspector.c41e977a.png";